module.exports = __webpack_public_path__ + "img/techforce-logo.14542ea9.jpg";